import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Models
import mInstallationAsyncOperation from 'models/installationAsyncOperation';
// Custom
import { getInstallationAsyncOperationHistory } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import SubListTemplate from 'components/templates/SubListTemplate';
import AsyncOperationRow from 'installations/assets/asyncOperations/AsyncOperationRow';
import Callout from 'components/misc/Callout';

const AsyncOperationHistory = ({
  id, asyncOperation, asyncOperationHistory, handleGetAsyncOperationHistory,
}) => {
  // Resource data
  const { resource_id: resourceId } = asyncOperation;
  const resourceType = mInstallationAsyncOperation.resourceType(asyncOperation);

  // Private
  const doGetRowComp = (props) => (
    <AsyncOperationRow {...props} withResource={false} />
  );

  return (
    <div className="row">
      <div className="col-12 col-md-6 information-item-wrapper">
        <InformationItem
          label={<LocalizedMessage id={resourceType.labelId} />}
          value={_toString(resourceId)}
        />
      </div>
      {asyncOperationHistory.error
        && (
        <div className="col-12 pt-3">
          <Callout severity="warning" withInfoIcon>
            <LocalizedMessage id="info.noHistoryAvaliable" />
          </Callout>
        </div>
        )}
      <div className="col-12">
        <SubListTemplate
          name={mInstallationAsyncOperation.name}
          listFeatures={mInstallationAsyncOperation.historyListFeatures}
          withQueryParams={false}
          elementsData={{
            loading: asyncOperationHistory.loading,
            elements: asyncOperationHistory.elements,
            handleGetList: (pagination, sort, filters) => handleGetAsyncOperationHistory(
              id,
              asyncOperation.id,
              pagination,
              sort,
              filters,
            ),
          }}
          rowComp={doGetRowComp}
        />
      </div>
    </div>
  );
};

AsyncOperationHistory.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  asyncOperation: PropTypes.shape({
    id: PropTypes.number.isRequired,
    resource_id: PropTypes.number.isRequired,
    resource_type: PropTypes.string.isRequired,
  }).isRequired,
  asyncOperationHistory: fullListShape.isRequired,
  handleGetAsyncOperationHistory: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  asyncOperationHistory: state.installationAsyncOperation.history,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetAsyncOperationHistory: (id, idAsyncOperation, pagination, sort, filters) => {
    dispatch(getInstallationAsyncOperationHistory(id, idAsyncOperation, pagination, sort, filters));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AsyncOperationHistory);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/asyncOperations/AsyncOperationHistory.js